import axios from "axios";

export const AuthService = () => {

    const login = async (email, password) => {
        return await axios.post(`${process.env.REACT_APP_API_URL}v1/auth/login`, {
            email,
            password
        });
    };

    const register = async (name, email, whatsapp, password, confirmPassword) => {
        return await axios.post(`${process.env.REACT_APP_API_URL}v1/auth/register`, {
            name,
            email,
            password,
            password_confirmation: confirmPassword
        });
    }

    const sendForgotEmail = async (email) => {
        return await axios.post(`${process.env.REACT_APP_API_URL}v1/auth/forgot/send-email`, {
            email
        });
    }

    const isValidToken = async (email, token) => {
        return await axios.get(`${process.env.REACT_APP_API_URL}v1/auth/forgot/isValidToken?email=${email}&token=${token}`);
    }

    const resetPassword = async (email, token, password, password_confirmation) => {
        return await axios.post(`${process.env.REACT_APP_API_URL}v1/auth/forgot/reset-password`, {
            email,
            token,
            password,
            password_confirmation
        });
    }

    return {
        login,
        register,
        sendForgotEmail,
        isValidToken,
        resetPassword
    };
};